import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { GetUserNamesModel } from "../../models/GetUserNamesModel";
import GetUserNamesService from "../../services/GetUserNamesService";
import GetUserNamesSlice from "../slices/GetUserNamesSlice";
import { RootState } from "../store";

export const GetUserNamesActions = GetUserNamesSlice.actions;
export const fetchAllBDPOCs = (userId: number): ThunkAction<void, RootState, unknown, AnyAction> => {
    return async (dispatch, getState) => {
            const response: GetUserNamesModel[] = await GetUserNamesService.getAllBDPOCs(userId);
            dispatch(GetUserNamesActions.setAllBDPOCs(response));
    }
}
export const fetchAllBDHeads = (userId: number): ThunkAction<void, RootState, unknown, AnyAction> => {
    return async (dispatch, getState) => {
            const response: GetUserNamesModel[] = await GetUserNamesService.getAllBDHeads(userId);
            dispatch(GetUserNamesActions.setAllBDHeads(response));
    }
}
export const fetchAllSBUHeads = (userId: number): ThunkAction<void, RootState, unknown, AnyAction> => {
    return async (dispatch, getState) => {
            const response: GetUserNamesModel[] = await GetUserNamesService.getAllSBUHeads(userId);
            dispatch(GetUserNamesActions.setAllSBUHeads(response));
    }
}
export const fetchAllSBGHeads = (userId: number): ThunkAction<void, RootState, unknown, AnyAction> => {
    return async (dispatch, getState) => {
            const response: GetUserNamesModel[] = await GetUserNamesService.getAllSBGHeads(userId);
            dispatch(GetUserNamesActions.setAllSBGHeads(response));
    }
}
